export default {"src":"/_next/static/media/argo.a6dc51c4.svg","height":100,"width":250,"blurWidth":0,"blurHeight":0};